<template>
  <div class="toolbar_favorites toolbar-icon" :title="$t('title.favoriteProcess')" @click="setFavorite">
    <custom-icon :class-name="computedclassName" />
  </div>
</template>
<script>
import { Preferences } from "../../../utils/constants";
import CustomIcon from "../../commons/CustomIcon.vue";

export default {
  components: { CustomIcon },
  computed: {
    designId() {
      return this.$store.state.cells.current.id;
    },
    isFavorited() {
      return this.$store.state.preferences.allPreferences.favoriteProcesses?.includes(this.designId);
    },
    computedclassName() {
      return this.isFavorited ? "icon-star-3" : "icon-star";
    },
  },
  methods: {
    setFavorite() {
      this.$store.dispatch("preferences/toggleFavorites", {
        type: Preferences.FavoriteProcesses,
        ids: this.designId,
      });
    },
    callFunc() {
      this.setFavorite();
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../assets/styles/variables.less";
.toolbar_favorites {
  padding: 0 0.3rem;
}
</style>
